import React from "react";
import { useContext, useState, useEffect } from "react";
// import "../../Playgame.css";
import "./Style.css";
// import games from "../../../data/gameAssets";
import RewardCard from "../../../component/Cards/Reward";
import RoomCard from "../../../component/Cards/RoomCard";
import ChallengesCard from "../../../component/Cards/ChallengesCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { useAuthContext } from "../../../AuthContext";
// import { GameContext } from "../../../component/Context/noteContext";
import OnevsOne from "../../../component/1vs1journey/Onevsone";
import Addbuddy from "../../../component/1vs1journey/Addbuddy";
import { GetGameDetails, customBets } from "../../../GameServices/GameServices";
import JoinRoom from "../../../component/1vs1journey/JoinRoom";
import CustomBetPopUp from "../../../component/1vs1journey/CustomBetPopUp";
import { GamePopupContext } from "../../../component/Context/GamePopupContext";
import { Link } from "react-router-dom";
import PaymentPopUp from "../../Playgame/PaymentPopup/PaymentPopUp";
import { useAuthContext } from "../../../AuthContext";

function PlayGameMobile() {
  const props = useParams();
  const navigate = useNavigate();
  const [GameData, setGameData] = useState([]);
  const [glory, setGlory] = useState();
  const [CustomBets, setCustomBets] = useState([]);
  const [paymentPopUp, setPaymentPopup] = useState(false);
  const { dispatchPopUp } = useContext(GamePopupContext);
  const { isAuthenticated } = useAuthContext();
  const location = useLocation();
  useEffect(() => {
    FetchGames();
  }, [props.id]);
  const FetchGames = async () => {
    let { data } = await GetGameDetails(props.id);
    setGameData(data);
    FetchCustomBets(data?.name);
  };
  const FetchCustomBets = async (name) => {
    let id = localStorage.getItem("user_id");
    let { data } = await customBets(id, name);
    setCustomBets(data);
  };
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  useEffect(() => {
    const Interval = setInterval(() => {
      setGlory(randomIntFromInterval(0, 9));
    }, 2000);
    return () => {
      clearInterval(Interval);
    };
  }, []);
  const practiceGame = (id, type, game) => {
    navigate(`/match`, {
      state: {
        id,
        type: type,
        value: 0,
        name: GameData?.name,
        gameBuild: GameData?.gameBuild,
        gameClass: GameData?.gameClass,
        practice: true,
      },
    });
  };
  function gameChanger(id, type, value, game) {
    if (!isAuthenticated) {
      setPaymentPopup(true);
    } else {
      navigate(`/match`, {
        state: {
          id,
          type: type,
          value: value,
          name: GameData?.name,
          gameBuild: GameData?.gameBuild,
          gameClass: GameData?.gameClass,
          gameType: "OneVSOne",
          direct: false,
          code: "",
        },
      });
    }
  }
  const handlePropGameChange = (params) => {
    navigate(`/match`, {
      state: {
        id: params.id,
        type: params.type,
        value: parseInt(params.value),
        name: GameData?.name,
        gameBuild: GameData?.gameBuild,
        gameClass: GameData?.gameClass,
        isCustomBet: true,
        gameType: "OneVSOne",
        direct: false,
        code: "",
      },
    });
  };
  return (
    <div className="game-detail-mbl hz-playgamemobile">
      <div className="overflow-x-hidden position-relative">
        <section className="playgame-sec">
          <div className="container-1280">
            <div className="row">
              <div className="col-lg-12 txt-centr-grad-main">
                <div className="txt-centr-grad">
                  <img src={require("../../../Assets/img/diamond.png")} alt="battle" />
                  <h1>
                    Play <span>1 vs 1</span>
                  </h1>
                </div>
                <h2 className="pink-blue-txt">STAGES</h2>
              </div>
            </div>
          </div>
        </section>
        <section className="games-sec">
          <div className="container-1280">
            <div className="row">
              <RewardCard
                glow={glory === 1 ? true : false}
                rating={1.8}
                price="01"
                play={() =>
                  gameChanger(
                    0,
                    GameData.stages ? GameData.stages[0].stage : 1,
                    // Moralis.Units.ETH(GameData?.stages[0].price),
                    GameData?.stages[0].price /* game price to be converted to ETH later */,
                    GameData?.name
                  )
                }
              />
              <RewardCard
                glow={glory === 2 ? true : false}
                rating="09"
                price="05"
                play={() =>
                  gameChanger(
                    1,
                    GameData.stages ? GameData.stages[1].stage : 2,
                    // Moralis.Units.ETH(GameData?.stages[1].price),
                    GameData?.stages[1].price /* game price to be converted to ETH later */,
                    GameData?.name
                  )
                }
              />
              <RewardCard
                glow={glory === 3 ? true : false}
                rating={18}
                price="10"
                play={() =>
                  gameChanger(
                    2,
                    GameData.stages ? GameData.stages[2].stage : 2,
                    // Moralis.Units.ETH(GameData?.stages[2].price),
                    GameData?.stages[2].price /* game price to be converted to ETH later */,
                    GameData?.name
                  )
                }
              />
              <RewardCard
                glow={glory === 4 ? true : false}
                rating={90}
                price="50"
                play={() =>
                  gameChanger(
                    3,
                    GameData.stages ? GameData.stages[3].stage : 3,
                    // Moralis.Units.ETH(GameData?.stages[3].price),
                    GameData?.stages[3].price /* game price to be converted to ETH later */,
                    GameData?.name
                  )
                }
              />
            </div>
          </div>
        </section>
        <section className="play-friends">
          <div className="container-1280">
            <div className="row">
              <div className="col-lg-12 txt-centr-grad-main">
                <div className="txt-centr-grad">
                  <img src={require("../../../Assets/img/cup.png")} alt="battle" />
                  <h1>
                    Play With <span className="pink-blue-txt">Friends</span>
                  </h1>
                </div>
                <h2>More Options</h2>
              </div>

              <RoomCard
                glow={glory === 5 ? true : false}
                mobile={true}
                title="Create & Play Custom Room"
                subtitle="Lets Create"
                img={require("../../../Assets/img/kids.png")}
                name="LUDO"
              />
              <RoomCard
                glow={glory === 6 ? true : false}
                mobile={true}
                title="Join A Room"
                subtitle="Join Now"
                img={require("../../../Assets/img/gameroom.png")}
                name="JOIN_ROOM"
              />
              <RoomCard
                glow={glory === 7 ? true : false}
                mobile={true}
                title="Free Game Play"
                subtitle="Play for free"
                img={require("../../../Assets/img/console.png")}
                play={() => practiceGame(0, GameData?.stages[0].stage, GameData.name)}
              />
              <RoomCard
                glow={glory === 8 ? true : false}
                mobile={true}
                title="Play Tournament & Earn Big"
                img={require("../../../Assets/img/trophy.png")}
              />
            </div>
          </div>
        </section>
        <section className="challenges games-sec">
          <div className="container-1280">
            <div className="row row-three">
              <div className="col-lg-12 txt-centr-grad-main">
                <div className="txt-centr-grad">
                  <img src={require("../../../Assets/img/dart.png")} alt="battle" />
                  <h1>
                    Open<span className="pink-blue-txt">Challenges</span>
                  </h1>
                </div>

                <h2>Challenge Now!</h2>
              </div>

              <div className="row second-row">
                <div className="col-lg-6 col-md-12 ">
                  <div className="d-flex w-100 red-box">
                    {CustomBets?.challenges?.slice(0, 4)?.map((item, index) => {
                      return (
                        <ChallengesCard
                          glow={glory === 9 ? true : false}
                          col={"2"}
                          key={index}
                          gameInfo={item}
                          isAuthenticated={isAuthenticated}
                          handlePopup={(value) => setPaymentPopup(value)}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="col-lg-6 col-md-12">
                  <div className="plac-img-txt">
                    <h2>Place Your Own Bet</h2>
                    <img src={require("../../../Assets/img/cartoon.png")} alt="battle" />
                  </div>

                  <a className="btn-play" onClick={() => dispatchPopUp({ type: "open", name: "CUSTOM_BET" })}>
                    Play Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="absolute-sm-imgs">
          <div className="asi-1">
            <img
              src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
              alt=""
            />
          </div>
          <div className="asi-2">
            <img
              src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
              alt=""
            />
          </div>
          <div className="asi-3">
            <img
              src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
              alt=""
            />
          </div>
          <div className="asi-4">
            <img
              src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
              alt=""
            />
          </div>
          <div className="asi-5">
            <img
              src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
              alt=""
            />
          </div>
        </section>
        <div className="footer-fixed">
          <footer className="mobile-footer">
            <div className="btn-main">
              <img src={require("../../../Assets/img/btn.png")} />
            </div>

            <div className="container">
              <div className="bottom-area">
                <ul className="footer-l-txt">
                  <Link to="/">
                    <li>Home</li>
                  </Link>
                  <li>Tournament</li>
                </ul>
                <ul className="footer-r-txt">
                  <li>NFTs</li>
                  <li>Profile</li>
                </ul>
              </div>
            </div>
          </footer>
        </div>

        <OnevsOne gameImage={GameData} />
        <JoinRoom gameImage={GameData} />
        <CustomBetPopUp
          gameImage={GameData}
          betHandler={(data) => {
            handlePropGameChange(data);
          }}
        />
        <Addbuddy play={() => practiceGame(0, GameData?.stages[0]?.stage, GameData?.name)} />
      </div>
      <OnevsOne gameImage={GameData} />
      <JoinRoom gameImage={GameData} />
      <CustomBetPopUp
        gameImage={GameData}
        betHandler={(data) => {
          handlePropGameChange(data);
        }}
      />
      <Addbuddy play={() => practiceGame(0, GameData?.stages[0]?.stage, GameData?.name)} />{" "}
      <PaymentPopUp
        show={paymentPopUp}
        closeModal={() => setPaymentPopup(false)}
        playPractice={() => practiceGame(0, GameData?.stages[0].stage, GameData.name)}
      />
    </div>
  );
}
export default PlayGameMobile;
